import { Checkbox } from "@shopify/polaris"
import { useCallback } from "react"

const ProductVariantCheckbox = (props) => {
	const handleChange = useCallback((newChecked) => {
		props.onChange(props.id, newChecked)
	}, [])

	return (
		<Checkbox
			label={props.label}
			checked={props.checked}
			onChange={handleChange}
		/>
	)
}

export default ProductVariantCheckbox
